module.exports = __webpack_public_path__ + "static/media/itilt.bcc24074.svg";